import React from 'react';
import { PieChart, Pie, Sector, Cell, ResponsiveContainer } from 'recharts';


const ResultOverviewSection = (props) => {
const resultMarksDetail = props.resultDetail !== undefined && props.resultDetail;
const resultDetail = props.resultDetail.summary !== undefined && props.resultDetail.summary;

    const PercentileData = [
    { name: 'average', value: 100 },
    { name: 'your', value: parseInt(resultDetail.percentile) },
  
    ];
    const PERCENTILE_COLORS = ['#AEE4B7', '#FFFFFF'];

    const Markdata = [
        { name: 'average', value: parseInt(resultDetail.max_marks) },
        { name: 'your', value: parseInt(resultDetail.obtain_marks) },
      
      ];
      const MARKDATA_COLORS = ['#868FA9', '#3569FF'];
      const percentData = [
          { name: 'average', value: 100 },
          { name: 'your', value: parseInt(resultDetail.percentage) },
        ];

        const PERCENT_COLORS = ['#ffd8b4', '#FFFFFF'];
      
      

    return (
        <>
        <div className='card p-3 mb-4'>
            <h5 className='text_primary'>Result Overview (TALLENTEX 2023-2024)</h5>
            <div className='innerWidget_wrap d-flex flex-wrap align-items-center justify-content-between'>
            
                <div className='innerWidget_item bg_success'>
                    <div className='data_contain'>
                        <span>Percentile</span>
                        <h3>
                        {resultDetail.percentile}
                            {/* {resultDetail.percentage+'%'} */}
                            </h3>
                    </div>
                    <div className='chart_Contain'>
                        <PieChart width={50} height={60} >
                            <Pie
                            data={PercentileData}
                            cx={20}
                            cy={30}
                            innerRadius={15}
                            outerRadius={20}
                            strokeWidth={0}
                            fill="#8884d8"
                            paddingAngle={1}
                            dataKey="value"
                            >
                            {PercentileData.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={PERCENTILE_COLORS[index % PERCENTILE_COLORS.length]} />
                            ))}
                            </Pie>
                        </PieChart>
                    </div>
                </div>
                
                <div className='innerWidget_item bg_primary'>
                    <div className='data_contain'>
                        <span>Marks</span>
                        <h3>{resultDetail.obtain_marks}</h3>
                    </div>
                    <div className='chart_Contain'>
                        <>
                        <PieChart width={50} height={60} >
                            <Pie
                            data={Markdata}
                            cx={20}
                            cy={30}
                            innerRadius={15}
                            outerRadius={20}
                            strokeWidth={0}
                            fill="#8884d8"
                            paddingAngle={1}
                            dataKey="value"
                            >
                            {Markdata.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={MARKDATA_COLORS[index % MARKDATA_COLORS.length]} />
                            ))}
                            </Pie>
                        </PieChart>
                        </>
                    </div>
                    
                </div>
                <div className='innerWidget_item bg_Orange'>
                    <div className='data_contain'>
                        <span>Percentage</span>
                        <h3>{resultDetail.percentage+'%'}</h3>
                    </div>
                    <div className='chart_Contain'>
                        <PieChart width={50} height={60} >
                            <Pie
                            data={percentData}
                            cx={20}
                            cy={30}
                            innerRadius={15}
                            outerRadius={20}
                            strokeWidth={0}
                            fill="#8884d8"
                            paddingAngle={1}
                            dataKey="value"
                            >
                            {percentData.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={PERCENT_COLORS[index % PERCENT_COLORS.length]} />
                            ))}
                            </Pie>
                        </PieChart>
                    </div>
                </div>

             
                <div className='innerWidget_item bg_navyBlue'>
                    <div className='data_contain'>
                        <span>Total Marks : <b>{resultDetail.max_marks}</b></span>
                        <span>Highest  : <b>{resultMarksDetail.highest_marks}%</b></span>
                        <span>Average  : <b>{resultMarksDetail.average_score}%</b></span>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default ResultOverviewSection